import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import {
  MergeDocumentSignWithCertificateBySignerTokenRequest,
  MergeDocumentSignWithCertificateBySignerTokenResponse,
} from "@maven-rest/docs/DocumentMerge.dto";
import { DocumentSignMergeUrl } from "@maven-rest/docs/DocumentSignMerge.url";

export function useMergeDocumentSignWithCertificateBySignerTokenMutation(
  req: MergeDocumentSignWithCertificateBySignerTokenRequest,
  options?: SimpleMutationOptions<
    MergeDocumentSignWithCertificateBySignerTokenResponse,
    MergeDocumentSignWithCertificateBySignerTokenRequest
  >
) {
  return useBaseMutation({
    fnOption: {
      url: DocumentSignMergeUrl.mergeDocumentSignWithCertificateBySignerToken(req.signerToken),
    },
    ...options,
  });
}
